// Voice API Service
import { getAuthHeaders } from "./auth";

// API_BASE_URL can be configured via environment variable
const API_BASE_URL = process.env.API_BASE_URL || "";

// Fetch available voices from backend
// GET /voices (provider is determined by backend DEFAULT_TTS_PROVIDER)
export async function getVoices() {
  const url = `${API_BASE_URL}/voices`;
  const headers = getAuthHeaders();
  
  console.log('[getVoices] URL:', url);
  console.log('[getVoices] Headers:', headers);
  
  const response = await fetch(url, { headers });

  console.log('[getVoices] Response status:', response.status);
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || "Failed to fetch voices");
  }

  return response.json();
}

// Get voice preview sample URL
export function getVoicePreviewUrl(voice) {
  return voice?.preview_url || null;
}

// Default voice ID (Kokoro Bella)
export const DEFAULT_VOICE_ID = "af_bella";
export const DEFAULT_VOICE_NAME = "Bella";

// Default voices to use as fallback if API fails
// These match the Kokoro voices from the backend
export const DEFAULT_VOICES = [
  {
    voice_id: "af_bella",
    name: "Bella",
    category: "system",
    gender: "female",
    accent: "american",
    description: "Friendly and approachable female voice",
  },
  {
    voice_id: "am_adam",
    name: "Adam",
    category: "system",
    gender: "male",
    accent: "american",
    description: "Deep and authoritative male voice",
  },
  {
    voice_id: "am_michael",
    name: "Michael",
    category: "system",
    gender: "male",
    accent: "american",
    description: "Energetic and dynamic male voice",
  },
  {
    voice_id: "af_nova",
    name: "Nova",
    category: "system",
    gender: "female",
    accent: "american",
    description: "Modern and dynamic female voice",
  },
  {
    voice_id: "am_eric",
    name: "Eric",
    category: "system",
    gender: "male",
    accent: "american",
    description: "Professional male voice",
  },
];

// Format voice for display in dropdown
export function formatVoiceLabel(voice) {
  const parts = [voice.name];
  
  if (voice.description) {
    parts.push(`- ${voice.description}`);
  }
  
  const meta = [];
  if (voice.gender) meta.push(voice.gender);
  if (voice.accent) meta.push(voice.accent);
  
  if (meta.length > 0) {
    parts.push(`(${meta.join(", ")})`);
  }
  
  return parts.join(" ");
}
